import React, { memo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { hitSlop, rem, Spacer } from 'design-system';
import { IconBoldAdd } from 'design-system/icons/IconBoldAdd';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounce from 'utils/packages/TouchableBounce';
const RemovedItem = ({ title, onAdd, icon, style }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    return (<View style={[styles.rowItem, style]}>
      <TouchableBounce onPress={onAdd} hitSlop={hitSlop} testID="OrganizeAdd">
        <IconBoldAdd color={colors.elements.positive}/>
      </TouchableBounce>
      <Spacer w={16}/>
      {icon ? (<>
          {icon}
          <Spacer w={16}/>
        </>) : null}
      <Text Text-16 flex>
        {title || ''}
      </Text>
    </View>);
};
export default memo(RemovedItem);
const styleSet = createStyleSheets((colors) => ({
    rowItem: {
        borderWidth: 1,
        padding: rem(16),
        overflow: 'hidden',
        flexDirection: 'row',
        borderRadius: rem(12),
        marginVertical: rem(5),
        marginHorizontal: rem(16),
        borderColor: colors.background.dark,
        backgroundColor: colors.background.dark,
    },
}));
